import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {withTrackFont} from '../../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import styles from './Button.scss';

interface IProps {
  className?: string;
  trackFont: object;
  theme?: string;
  onClick?: React.MouseEventHandler;
  dataHook?: string;
  disabled?: boolean;
  children: React.ReactNode;
}

const ButtonComponent: React.FunctionComponent<IProps> = ({
  trackFont,
  className,
  theme = 'medium',
  dataHook = 'button',
  onClick,
  children,
  disabled,
  ...props
}) => {
  const buttonStyle = withoutSize(trackFont);
  return (
    <button
      className={classNames(styles.button, styles[theme], {[styles.disabled]: disabled}, className)}
      style={buttonStyle}
      onClick={onClick}
      data-hook={dataHook}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

ButtonComponent.propTypes = {
  className: PropTypes.string,
  trackFont: PropTypes.object.isRequired,
  theme: PropTypes.string,
  onClick: PropTypes.func,
  dataHook: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export const Button = withTrackFont(ButtonComponent);
